module.exports = __webpack_public_path__ + "img/fenxiangzhuanqian.addba1fb.svg";